import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://gazfduoumclmczxravnt.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdhemZkdW91bWNsbWN6eHJhdm50Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDAyMjAzMTAsImV4cCI6MjAxNTc5NjMxMH0._-KA-Jw84Put6oSfgiLBmzamV-5goTDEvTnCApW6dZQ";

const supabaseClient = createClient(supabaseUrl, supabaseKey);

export default supabaseClient;
